export default {
	authReady: false,
	authToken: null,
	refreshToken: null,
	userId: null,
	currentSessionId: null,
	profiles: [],
	profileLoading: false,
	accountRecoverCredentialsId: null,
	accountRecoverLoginId: null,
	credentials: [],
	currentCredentialsId: null,
	authFlowPayload: null,
	authFlowWithProvider: false,
	pendingAccountConfirmation: false,
	sessions: [],
	refreshDeadline: null,
}
